import { AfterViewInit, Component, ViewEncapsulation, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { CompanyService } from 'src/app/services/company/company.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-performa-add-company-modal',
  templateUrl: './performa-add-company-modal.component.html',
  styleUrls: ['./performa-add-company-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PerformaAddCompanyModalComponent extends DestructorComponent implements OnInit, AfterViewInit {

  @Output() companyAdded = new EventEmitter<void>();

  countryList: any[] = [];
  companyForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _companyService: CompanyService,
    private _globalStateService: GlobalStateService
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    // Subscribe to countries from GlobalStateService
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe(countries => {
        this.countryList = countries || [];
      })
    );
  }

  ngAfterViewInit(): void {
    // After view initialization
  }

  initializeForm() {
    this.companyForm = this.fb.group({
      title: ['Mr.', [Validators.required]],
      name: ['', [Validators.required]],
      company: ['', [Validators.required]],
      address: [''],
      city: [''],
      state: [''],
      zip: [''],
      port: [''],
      country: [''],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
      mobile: [''],
      fax: [''],
      skype_id: ['']
    });
  }

  onSubmit() {
    if (this.companyForm.valid && !this.isLoading) {
      this.isLoading = true;

      // Prepare data for API
      const formData = this.companyForm.value;
      const submitData = {
        title: formData.title,
        name: formData.name,
        company: formData.company,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip: formData.zip,
        port: formData.port,
        country: formData.country,
        email: formData.email,
        phone: formData.phone,
        mobile: formData.mobile,
        fax: formData.fax,
        skype_id: formData.skype_id
      };

      // Call the CompanyService AddData method
      this.subscriptions.push(
        this._companyService.AddData(submitData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            console.log('Company created successfully:', response);

            // Show success message
            Swal.fire({
              text: "Company has been successfully created!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            }).then((result: any) => {
              if (result.isConfirmed) {
                // Close the modal
                this.closeModal();

                // Emit event to refresh the listing
                this.companyAdded.emit();

                // Reset the form
                this.resetForm();
              }
            });
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Error creating company:', error);

            // Show error message
            Swal.fire({
              text: error.error?.message || "Sorry, looks like there are some errors detected, please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        })
      );
    } else {
      // Mark all fields as touched to show validation errors
      this.companyForm.markAllAsTouched();
    }
  }

  // Helper method to close modal
  closeModal() {
    const modalElement = document.getElementById('performa_add_company');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  // Helper method to reset form
  resetForm() {
    this.companyForm.reset();
    this.initializeForm();
  }

  // Helper method to clear form
  clearForm() {
    this.companyForm.reset();
    this.companyForm.patchValue({
      title: 'Mr.'
    });
  }
}
